import {
  ChartBarIcon,
  SparklesIcon,
  BeakerIcon,
  RocketLaunchIcon,
  CurrencyDollarIcon,
  LockClosedIcon,
  ClipboardDocumentCheckIcon,
  GiftIcon,
  ArrowsPointingOutIcon,
  Cog6ToothIcon,
  PencilSquareIcon,
  BanknotesIcon
} from '@heroicons/react/24/outline';
import { motion } from 'framer-motion';
import { useTranslations } from 'next-intl';

export const Features = () => {
  const t = useTranslations('features');

  const features = [
    { id: 'instantScaling', icon: RocketLaunchIcon },
    { id: 'flexiblePlans', icon: SparklesIcon },
    { id: 'transparentPayouts', icon: BeakerIcon },
    { id: 'multichannelSupport', icon: ChartBarIcon },
    { id: 'multipleCurrencies', icon: CurrencyDollarIcon },
    { id: 'privateCampaigns', icon: LockClosedIcon },
    { id: 'applicantApproval', icon: ClipboardDocumentCheckIcon },
    { id: 'customRewards', icon: GiftIcon },
    { id: 'unlimitedTraffic', icon: ArrowsPointingOutIcon },
    { id: 'cookieControl', icon: Cog6ToothIcon },
    { id: 'customRegistration', icon: PencilSquareIcon },
    { id: 'manualPayments', icon: BanknotesIcon }
  ];

  const container = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.15 }
    }
  };

  const item = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
    hover: { scale: 1.05, boxShadow: '0 20px 30px rgba(0,0,0,0.1)' }
  };

  return (
      <motion.dl
          className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4"
          variants={container}
          initial="hidden"
          animate="visible"
      >
        {features.map((feature) => {
          const Icon = feature.icon;

          return (
              <motion.div
                  key={feature.id}
                  className="
              group relative flex flex-col justify-between
              rounded-2xl p-6
              bg-white
              text-gray-800
              transition-shadow duration-300 cursor-pointer
            "
                  variants={item}
                  whileHover="hover"
              >
                <div className="flex items-center space-x-4">
                  <div className={`${feature.bg} p-3 rounded-lg`}>
                    <Icon className="h-7 w-7 transition-transform duration-300 group-hover:rotate-12" />
                  </div>

                  <dt className="text-xl font-bold text-gray-800 transition-colors">
                    {t(`items.${feature.id}.title`)}
                  </dt>
                </div>

                <dd className="mt-4 text-sm text-gray-800 transition-colors">
                  {t(`items.${feature.id}.description`)}
                </dd>
              </motion.div>
          );
        })}
      </motion.dl>
  );
};

export default Features;